import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationFooter',
  props: {
    dataFooter: null,
    companyName: { default: "Eagle Eye Networks" }
  },
  setup(__props: any) {



const year = ref(new Date().getFullYear());

return { __sfc: true,year }
}

})